export default __webpack_public_path__ + "locales/pt-BR/Ldap.json?hash=f8ba7a8bdaae6588fec3a72a71b0e2fe";